// 用于将地区标识转为中文
export const areaJsonName = {
  gdzj: "湛江",
  gdyj: "阳江"
}

// 湛江可申报城市json
export const gdzjCityList = [{
  label: "广东省",
  value: "gd",
  children: [{
    label: "广州市",
    value: "4401",
  }, {
    label: "湛江市",
    value: "4408",
  }]
}, {
  label: "广西壮族自治区",
  value: "gx",
  children: [{
    label: "北海市",
    value: "4505",
  }, {
    label: "玉林市",
    value: "4509",
  }, {
    label: "钦州市",
    value: "4507",
  }]
}, {
  label: "海南省",
  value: "hn",
  children: [{
    label: "海口市",
    value: "4601",
  }]
}]